// request,oss

//拦截写在request里
import Vue from "vue";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import enLocale from "element-ui/lib/locale/lang/en"; //导入element ui中的默认英文配置
import zhLocale from "element-ui/lib/locale/lang/zh-CN"; //导入element ui中的默认中文配置
import esLocale from "element-ui/lib/locale/lang/es"; //导入element ui中的默认中文配置
import jaLocale from "element-ui/lib/locale/lang/ja"; //导入element ui中的默认中文配置
import Cookies from "js-cookie";
import jq from "jquery";
import App from "./App";
import { requestData, request_api } from "./request/request.js";
import "swiper/dist/css/swiper.min.css";
import "swiper/dist/js/swiper.min";
// 引入字体样式
import "./assets/fonts/text.css";

import zh from "./lang/zh";
import en from "./lang/en";
import sp from "./lang/sp";
import ja from "./lang/ja";

// i18n
import VueI18n from "vue-i18n";

Vue.use(VueI18n);
//上传图片并拖拽
import VueDND from "awe-dnd";
Vue.use(VueDND);

import BaiduMap from "vue-baidu-map";
Vue.use(BaiduMap, {
  ak: "nD6QsAIHmOMn8PBdC3VXwLfgrCsa6Amg",
});

Vue.directive("removeAriaHidden", {
  bind(el, binding) {
    const ariaEls = el.querySelectorAll(".el-radio__original");
    ariaEls.forEach((item) => {
      item.removeAttribute("aria-hidden");
    });
  },
});

const i18n = new VueI18n({
  locale: localStorage.getItem("locale") || "zh",
  messages: {
    zh: {
      ...zh,
      ...zhLocale,
    },
    en: {
      ...en,
      ...enLocale,
    },
    ja: {
      ...ja,
      ...jaLocale,
    },
    sp: {
      ...sp,
      ...esLocale,
    },
  },
});

Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value),
});

import store from "./store";
import Routers from "./router.js";

Vue.prototype.request = requestData;
Vue.prototype.$ = jq;

// 定义获取uuid的方法
Vue.prototype.$generateUUID = function () {
  var d = new Date().getTime();
  var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
    /[xy]/g,
    function (c) {
      var r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
    }
  );
  uuid = uuid.replace(/-/g, "");
  return uuid;
};

// Vue.filter("money", function (val) {
//   val = val.toString().replace(/[$,]/g, "");
//   if (isNaN(val)) {
//     val = "0";
//   }
//   let sign = val == (val = Math.abs(val));
//   val = Math.floor(val * 100 + 0.50000000001);
//   let cents = val % 100;
//   val = Math.floor(val / 100).toString();
//   if (cents < 10) {
//     cents = "0" + cents;
//   }
//   for (var i = 0; i < Math.floor((val.length - (1 + i)) / 3); i++) {
//     val =
//       val.substring(0, val.length - (4 * i + 3)) +
//       "," +
//       val.substring(val.length - (4 * i + 3));
//   }

//   return (sign ? "" : "-") + val + "." + cents;
// });
Vue.filter("money", function (value) {
  if (value === null || value === undefined || value === "") {
    return "";
  }

  // 转换为字符串
  let numStr = String(value);

  // 检查是否为有效数字
  if (isNaN(parseFloat(numStr))) {
    return value;
  }

  // 分割整数和小数部分
  const parts = numStr.split(".");
  let integerPart = parts[0];
  let decimalPart = parts.length > 1 ? "." + parts[1] : "";

  // 处理整数部分的千分位分隔
  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  // 返回格式化后的结果
  return integerPart + decimalPart;
});

Vue.config.productionTip = false;

new Vue({
  el: "#app",
  router: Routers,
  i18n,
  store,
  components: {
    App,
  },
  template: "<App/>",
});
// 注入

if (process.env.NODE_ENV === "production") {
  // 生产环境下(懒得找了，直接把console清了)
  window.console.log = function () {};
}



// WEBPACK FOOTER //
// ./src/main.js